var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"outlined":"","clearable":"","items":_vm.items,"menu-props":{ maxHeight: '200', zIndex: 13 },"label":"Type de recherche"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }